import request from './index'
import axios from 'axios'
// 获取验证码
export function IVerificationCode(params) {
    console.log(request)
    console.log(axios.request)
    return request({
        url: "/getCode",
        headers: {
            isToken: false,
        },

        params,
        method: "get",
        timeout: 20000,
    });
}





// WEBPACK FOOTER //
// ./src/api/public.js